import moment from 'moment-timezone';

export type TimeSegment = 'morning' | 'afternoon' | 'evening';

export const TIME_SEGMENTS: TimeSegment[] = ['morning', 'afternoon', 'evening'];

const SLOT_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';

/** 14:30 → 2:30 PM; anything unparseable is shown as given. */
export const formatTime = (timeStr: string): string => {
  const m = moment(timeStr, 'HH:mm');
  return m.isValid() ? m.format('h:mm A') : timeStr;
};

export const isSlotStartInFuture = (date: string, slotStart: string): boolean => (
  moment(`${date} ${slotStart}`, SLOT_DATE_TIME_FORMAT).isAfter(moment())
);

export const getTimeSegment = (hour: number): TimeSegment => {
  if (hour < 12) return 'morning';
  if (hour < 18) return 'afternoon';
  return 'evening';
};
